export const decodeHtml = (html) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = html;
  return textarea.value;
};

export const sanitizeXmlTag = (tag) => {
  if (!tag) return "div";

  const cleaned = tag.replace(/[^a-zA-Z0-9_]/g, "");

  if (/^[a-zA-Z_]/.test(cleaned)) {
    return cleaned;
  }

  return `f_${cleaned}`;
};

export const validateXPath = (formula, fieldName, fieldValue) => {
  if (!formula) return;

  const processedFormula = decodeHtml(
    formula.replaceAll("#", "").replaceAll(/(<([^>]+)>)/gi, "")
  );

  const individualXml = `<${sanitizeXmlTag(
    fieldName
  )}>${fieldValue}</${sanitizeXmlTag(fieldName)}>`;

  const parser = new DOMParser();
  const individualDoc = parser.parseFromString(individualXml, "text/xml");

  try {
    const resolver = individualDoc.createNSResolver(individualDoc);

    const xpathResult = individualDoc.evaluate(
      processedFormula,
      individualDoc,
      resolver
    );

    return xpathResult.booleanValue;
  } catch (error) {
    console.error(
      `Nie można zwalidować formuły xPath, nieprawidłowa formuła walidacyjna - "${processedFormula}"`
    );

    return false;
  }
};
